/*
These functions make sure WordPress
and Foundation play nice together.
*/

//var rellax = new Rellax('.rellax');
AOS.init();


jQuery(document).ready( function() {
  
  var options = {
    // or you can specify offset individually for up/down scroll
    offset: {
        up: 50,
        down: 50
    }
  };
  jQuery('#main-menu').headroom(options);
  jQuery('#mobile-menu').headroom(options);
  
  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      jQuery(this).wrap("<div class='responsive-embed'/>");
    }
  });
  
  jQuery('.section').mousemove(function(e){
    
    var wx = jQuery(window).width();
    var wy = jQuery(window).height();
    
    var x = e.pageX - this.offsetLeft;
    var y = e.pageY - this.offsetTop;
    
    var newx = x - wx/2;
    var newy = y - wy/2;
      
    jQuery('.parallax', jQuery(this)).each(function(){
      var speed = jQuery(this).attr('data-parallax-speed')/10;
      if(jQuery(this).attr('data-revert')) speed *= -1;
      TweenMax.to(jQuery(this), 1, {x: (1 - newx*speed), y: (1 - newy*speed)});
    });
    
  });
  
}); 

